import { render } from "./AddFounderModel.vue?vue&type=template&id=931c1014&scoped=true"
import script from "./AddFounderModel.js?vue&type=script&lang=js"
export * from "./AddFounderModel.js?vue&type=script&lang=js"

import "./AddFounderModel.vue?vue&type=style&index=0&id=931c1014&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-931c1014"]])

export default __exports__